import { useLocation } from "react-router-dom";
import { useExpressContext } from "src/layouts/dashboard/express-layout";
import { HouseholdChecklistExpress } from "src/sections/dashboard/overview/household-checklist-express";
import { usePageView } from "src/hooks/use-page-view";
import useHousehold, { ExperienceFlag } from "src/contexts/household-context";

// PHASE 7: Removed viewMode system - now using unified HouseholdChecklistExpress component
// that handles both intake and download modes at the row level

interface ExpressProps {
  // When true, navigate to index pages (e.g., /{ud_id}/wills-and-trusts) instead of express pages
  useIndexPaths?: boolean;
}

export default function Express({ useIndexPaths = false }: ExpressProps): JSX.Element {
  const location = useLocation();
  const isExpressRoute = location.pathname.startsWith("/express");

  const context = useExpressContext();
  const triggerConfetti = context?.triggerConfetti;
  const { experienceFlag } = useHousehold();
  usePageView();

  return (
    <HouseholdChecklistExpress
      express={isExpressRoute}
      readOnly={experienceFlag === ExperienceFlag.READONLY}
      triggerConfetti={triggerConfetti}
      setViewMode={undefined} // No longer needed, but keeping prop for backwards compatibility
      useIndexPaths={useIndexPaths}
    />
  );
};
